import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService {
  private apiUrl: string;
  private baseUrl: string;

  constructor() {
    this.initializeConfig();
  }

  private initializeConfig(): void {
    // Get the current hostname
    const hostname = window.location.hostname;
    
    // Map hostnames to API URLs
    const hostnameConfig: { [key: string]: { apiUrl: string; baseUrl: string } } = {
      'localhost': {
        apiUrl: 'http://localhost:9000',
        baseUrl: 'http://localhost:9000'
      },
      '127.0.0.1': {
        apiUrl: 'http://localhost:9000',
        baseUrl: 'http://localhost:9000'
      },
      'neptune.theredarc.com': {
        apiUrl: 'https://neptune.theredarc.com',
        baseUrl: 'https://neptune.theredarc.com'
      },
      // Add more hostname mappings as needed
      // 'staging.example.com': {
      //   apiUrl: 'https://api-staging.example.com',
      //   baseUrl: 'https://staging.example.com'
      // }
    };

    // Check if hostname exists in configuration, otherwise use default
    const config = hostnameConfig[hostname];
    
    if (config) {
      this.apiUrl = config.apiUrl;
      this.baseUrl = config.baseUrl;
    } else {
      // Default to production URL if hostname not found
      // You can also check if it's a development environment
      if (hostname.includes('localhost') || hostname.includes('127.0.0.1') || hostname.includes('192.168.') || hostname.includes('10.0.')) {
        this.apiUrl = 'http://localhost:9000';
        this.baseUrl = 'http://localhost:9000';
      } 

      if (hostname.includes('neptune.theredarc.com') || hostname.includes('tra-ecrf')) {
        this.apiUrl = 'https://neptune.theredarc.com';
        this.baseUrl = 'https://neptune.theredarc.com';
      }

      if (hostname.includes('tra-sandbox') || hostname.includes('neptune-sandbox') || hostname.includes('sandbox')) {
        this.apiUrl = 'https://neptune-sandbox.theredarc.com';
        this.baseUrl = 'https://neptune-sandbox.theredarc.com';
      }
    }

    console.log(`Environment configured for hostname: ${hostname}`);
    console.log(`API URL: ${this.apiUrl}`);
    console.log(`Base URL: ${this.baseUrl}`);
  }

  getApiUrl(): string {
    return this.apiUrl;
  }

  getBaseUrl(): string {
    return this.baseUrl;
  }
}

